import { Typography, Box, Paper } from "@mui/material";
import {
  QuillR2Editor,
  QUILL_MODULES,
  QUILL_FORMATS,
} from "../../../utils/quillQuestionEditorConfig";

const EssayAnswer = ({ value, onChange, showMathTools }) => (
  <Box>
    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: "#444" }}>
      Model Answer (optional)
    </Typography>
    <Paper
      elevation={0}
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: 1,
        background: "#fafafa",
        "& .ql-container": { minHeight: 150, fontSize: "0.95rem" },
      }}
    >
      <QuillR2Editor
        value={value || ""}
        onChange={onChange}
        modules={QUILL_MODULES}
        formats={QUILL_FORMATS}
        placeholder="Enter a model answer for reference..."
        showMathTools={showMathTools}
      />
    </Paper>
    <Typography variant="caption" sx={{ color: "#666", mt: 0.5, display: "block" }}>
      This answer will be shown to students after they submit their response.
    </Typography>
  </Box>
);

export default EssayAnswer;
